import {
  Button,
  List,
  Space,
  message,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Popconfirm,
  Col,
  Row,
  Divider,
  Tag, Spin
} from "antd";
import { NAIRA } from "../../defaults/utilities";
import {useState, useRef, useEffect} from "react";
import { EditOutlined, CheckOutlined, CloseCircleOutlined, SendOutlined, DeleteOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { formatCurrency } from "../../helpers/currency";
import DataTable from "../common/table";
import { DUMMY_BUDGET_ITEMS_DATA } from "./createBudgetComponent";
import { useApproveBudget, useDeleteBudget, useDownloadBudgetReport, useRejectBudget, useSubmitForApproval, useUpdateBudget } from "../../hooks/budget/budgetQuery";
import { userStore } from "../../store/userStore";
import { useFetchAllFinancialYears } from "../../hooks/financialYear/financialYearQuery";
import { useGetAlltBudgetItems } from "../../hooks/budgetItem/budgetItemQuery";
import { useGetMemoScope } from "../../hooks/memo-scopes/memoScopeQuery";
import { extractValueFromInputRef } from "../../helpers/dom";
import { useDepartments } from "../../hooks/department/departmentQuery";
import {InflowOutflow, NewInflowOutflow} from "../budgets/inflowOutflow";



const { Option } = Select;


export default function PreviewBudget({ item, handleModalClose, updateItem }) {
  const [editOpen, setEditOpen] = useState(false);
  const [currItem, setCurrItem] = useState({});
  const [currItems, setCurrItems] = useState([...item?.budgetItems]);
  const [year, setYear] = useState(item.financialYear.id);
  const [total, setTotal] = useState(0);
  const [itemState, setItemState] = useState(item)
  const [department, setdepartment] = useState(item?.office?.id);
  const [downloading, setDownloading] = useState(false)


  const titleRef = useRef(null)

  const approve = useApproveBudget();
  const reject = useRejectBudget();
  const submit = useSubmitForApproval();

  const deleteBudget = useDeleteBudget();

  const updateBudget = useUpdateBudget()

  const { budgetItems } = useGetAlltBudgetItems()

  const downloadBudgetReport = useDownloadBudgetReport();

  const scopes = useGetMemoScope();

  const { departments } = useDepartments();


  let AUTHORIZED_SCOPE = "";

  const user = userStore(state => state.user);

  const { years } = useFetchAllFinancialYears();

  switch (item.budgetScope.toLowerCase()) {
    case "unit":
      AUTHORIZED_SCOPE = "HEAD_OF_UNIT";
      break;

    case "department":
      AUTHORIZED_SCOPE = "HEAD_OF_DEPARTMENT";
      break;
    default:
      break;
  }

  const handleOpen = () => {
    handleModalClose();
    setEditOpen(true);
  }
  const handleClose = () => setEditOpen(false);


  const downloadReport = async (combined) => {
    setDownloading(true)
    const d = await downloadBudgetReport(department, year, false)
    setDownloading(false)
  }


  const createBudgetItemColumns = [
    {
      title: 'Item',
      key: 'item',
      dataIndex: 'budgetItem',
      render: (item) => (typeof item === "object" ? item.title : JSON.parse(item).title) + ' - ' + (typeof item === "object" ? item.code : JSON.parse(item).code)
    },
    {
      title: 'Amount',
      key: 'amount',
      dataIndex: 'amount',
      render: (amount) => `${NAIRA} ${formatCurrency(amount)}`
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, __, idx) => (
        <div style={{ display: 'flex', justifyContent: "flex-end" }}>
          {/* <Button type="primary" style={{ backgroundColor: "lightred" }} onClick={() => editItem(idx)}>Edit</Button> */}
          <Button type="primary" style={{ backgroundColor: "red", marginLeft: "2em" }} onClick={() => removeItem(idx)}>Remove Item</Button>
        </div>
      )
    }
  ]

  function removeItem(id) {
    const item = currItems.find((_, itemIndex) => itemIndex === id);
    setTotal(prevTotal => prevTotal -= +(item.amount));
    setCurrItems((prevItems) => (prevItems.filter((_, idx) => idx !== id)))
  }

  function editItem(id) {
    const item = currItems.find((_, itemIndex) => itemIndex === id);
    removeItem(id)
    // add to edit
    document.getElementById("btnAdd").click()
    setCurrItem(...item)
  }

  function addItem(callback1, callback2) {
    // setCurrItem((prev)=>({...prev,id:index}));
    setCurrItems((prev) => {
      return [...prev, currItem]
    });
    setTotal(prevTotal => prevTotal += +(currItem.amount));
    setCurrItem({});
    callback1()
    callback2();
    // index++;
  }

  const approveBudget = async () => {
    const response = await approve(item.id)
    message.success('Budget Approved Successfully');
    updateItem(response)
    handleModalClose();
  }

  const rejectBudget = async () => {
    const response = await reject(item.id);
    message.success('Budget rejected successfully');
    updateItem(response)
    handleModalClose();
  }

  const submitForApproval = async () => {
    const response = await submit(item.id)
    message.success('Budget Submitted Successfully');
    updateItem(response)
    handleModalClose();
  }


  const handleUpdateBudget = async () => {
    const payload = {
      title: extractValueFromInputRef(titleRef),
      financialYear: year,
      departmentId: department,
      budgetItems: currItems.map(i => ({ ...i, budgetItem: typeof i.budgetItem === "object" ? i.budgetItem.id : JSON.parse(i.budgetItem).id })),
    }
    const { message: response } = await updateBudget(item.id, payload);
    setEditOpen(false);
    message.success(response ?? "budget updated successfully");
  }

  const handleDeleteBudget = async () => {
    const { message: response } = await deleteBudget(item.id);
    handleModalClose();
    message.success(response ?? "budget deleted successfully");
    return;
  }
  return (
    <>
      <div style={{ marginTop: "3em", maxHeight: "70vh", overflowY: "scroll", paddingLeft: "2em", paddingRight: "2em" }}>

        <div style={{ padding: "1em" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Budget Title:</span>
            <span style={{ fontWeight: "bold" }}>{item?.title}</span>
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Financial Year:</span>
            <span style={{ fontWeight: "bold" }}>{item.financialYear?.title}</span>
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Office:</span>
            <span style={{ fontWeight: "bold" }}>{item.office?.title}</span>
          </div>
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
          <span>Budget Breakdown:</span>
          <List
            bordered
            style={{ marginBottom: '2em', }}
            itemLayout="vertical"
            dataSource={item.budgetItems}
            renderItem={(it, idx) => (
              <>
                <List.Item key={it.id}>
                  <div className="buget-item-list" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}>
                    <div style={{flexBasis: '30%'}}>
                      <span style={{fontWeight: 'bold', marginRight: '5px'}}>{idx + 1}. </span>
                      {it.budgetItem?.title} - {it.budgetItem?.code}
                    </div>
                    <div style={{textAlign: 'right', flexBasis: '15%'}}>
                      {NAIRA} {formatCurrency(it.amount)}
                    </div>
                    <div style={{color: 'red', textAlign: 'right', flexBasis: '15%'}}>
                      -{NAIRA} {formatCurrency(it.spent)}
                    </div>
                    <div style={{color: 'green', textAlign: 'right', flexBasis: '15%'}}>
                      + {NAIRA} {formatCurrency(it.amount - it.spent)}
                    </div>
                    {/*<div style={{textAlign: 'right', flexBasis: '25%'}}>*/}
                    {/*  {*/}
                    {/*    item.submitted && <Space>*/}
                    {/*        <InflowOutflow item={it} />*/}
                    {/*        <NewInflowOutflow budgetItem={it} onUpdate={() => {}}/>*/}
                    {/*      </Space>*/}
                    {/*  }*/}
                    {/*</div>*/}
                  </div>
                </List.Item>
                {
                    (idx === (item.budgetItems.length - 1)) &&
                    <List.Item key={Math.random()}>
                      <div className="buget-item-list" style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}>
                        <div style={{flexBasis: '30%'}}>
                          <span style={{fontWeight: 'bold', marginRight: '5px'}}>Totals </span>

                        </div>
                        <div style={{textAlign: 'right', flexBasis: '15%'}}>
                          {NAIRA} {formatCurrency(item.budgetItems.map(b => b.amount).reduce((i, c) => i + c, 0))}
                        </div>
                        <div style={{color: 'red', textAlign: 'right', flexBasis: '15%'}}>
                          -{NAIRA} {formatCurrency(item.budgetItems.map(b => b.spent).reduce((i, c) => i + c, 0))}
                        </div>
                        <div style={{color: 'green', textAlign: 'right', flexBasis: '15%'}}>
                          + {NAIRA} {formatCurrency(item.budgetItems.map(b => b.amount).reduce((i, c) => i + c, 0) - item.budgetItems.map(b => b.spent).reduce((i, c) => i + c, 0))}
                        </div>

                      </div>
                    </List.Item>
                }
              </>
            )}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: "1em" }}>
          <Space direction="horizaontal" wrap align="center">
            {
              user.id === item.createdBy.id && (
                <>
                  <Button type='primary' onClick={() => handleOpen()} disabled={item.submitted}>
                    <EditOutlined />
                    Edit
                  </Button>
                  <Popconfirm
                    title="Delete this budget item"
                    description="Are you sure to delete this budget item?"
                    onConfirm={handleDeleteBudget}
                    onCancel={() => null}
                    okText="Yes"
                    cancelText="No"
                    disabled={item.submitted}
                  >
                    <Button type="primary" danger disabled={item.submitted}>
                      <DeleteOutlined />
                      Delete
                    </Button>
                  </Popconfirm>
                  {
                    !item.submitted &&
                    <Button type='primary' style={{ backgroundColor: 'green' }} onClick={() => submitForApproval()}>
                      <CheckOutlined />
                      Submit
                    </Button>
                  }
                </>
              )
            }
            {
              (item.submitted && !item.finalApproved && user.roles?.includes(item.nextApprovalStage?.role)) &&
              <>
                <Button type='primary' style={{ backgroundColor: 'green' }} onClick={() => approveBudget()}>
                  <CheckOutlined />
                  Approve
                </Button>
                <Button type='primary' style={{ backgroundColor: "orange" }} onClick={() => rejectBudget()}>
                  <CloseCircleOutlined />
                  Reject
                </Button>
              </>
            }

            <div>
              <Button loading={downloading} onClick={downloadReport} style={{ backgroundColor: "green", color: "#FFFFFF" }} >
                Download Report
              </Button>
            </div>
          </Space>
        </div>
      </div>
      <Modal title={"Update Budget Item"} open={editOpen} onCancel={() => handleClose()} footer={null} width={"75vw"}>
        <Form initialValues={{
          ...item,
          items: item.budgetItems,
          year: item.financialYear.id,
          department: item.department?.id ?? null
        }}>
          <Form.Item name='title'>
            <Input ref={titleRef} placeholder="Budget Name" />
          </Form.Item>
          <Form.Item name="year">
            <Select placeholder="Select Financial year" onChange={(e) => setYear(e)}>
              {
                years.map((y, idx) => (
                    <Option value={y.id} key={idx}>{y.value}</Option>
                ))
              }
            </Select>
          </Form.Item>


          {
            currItems.length > 0 && (
              <DataTable cols={createBudgetItemColumns} data={currItems} pagination={false} rowKey={(item) => item.budgetItem.id} />
            )
          }
          <Form.List name="eitems" style={{ width: '100%' }}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: 8,
                      marginTop: 4,
                      width: '100%',
                      justifyContent: 'space-between'
                    }}
                    align="baseline"
                  >
                    <Form.Item
                      {...restField}
                      name={[name, 'item']}
                      rules={[
                        {
                          required: true,
                          message: 'Missing Budget Item',
                        },
                      ]}
                    >
                      <Select 
                        placeholder='Item' 
                        style={{ width: '20em' }} 
                        onChange={(e) => setCurrItem((prevItem) => ({ ...prevItem, budgetItem: e }))}
                        showSearch
                        filterOption={(input, option) => 
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {
                          budgetItems.length > 0 && (
                            budgetItems.map((item, idx) => (
                              <Option value={JSON.stringify({ id: item.id, value: item.code, title: item.title })} key={idx}>{item.title + '-' + item.code}</Option>
                            ))
                          )
                        }
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'amount']}
                      rules={[
                        {
                          required: true,
                          message: 'Missing Budget Amount',
                        },
                      ]}
                    >
                      <InputNumber style={{ width: '100%' }} prefix={NAIRA} placeholder="Budget Item Amount" onChange={(e) => setCurrItem((prevItem) => ({ ...prevItem, amount: e }))} />
                    </Form.Item>
                    <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                      <Form.Item>
                        <Button type='primary' style={{ backgroundColor: 'lime' }} onClick={() => addItem(() => remove(name), add)}>
                          Add Item
                        </Button>
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} style={{ marginTop: ".5em", marginLeft: "4px" }} />
                    </div>

                  </Space>
                ))}
                <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
                  <span style={{ fontWeight: 'bold' }}>Total : {NAIRA} {total}</span>
                </div>
                <Form.Item>
                  <Button id={'btnAdd'} type="primary" onClick={() => add()} icon={<PlusOutlined />}>
                    {item.budgetItems.length < 1 ? 'Add Budget Item' : 'Add Another Item'}
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Form.Item wrapperCol={{
            span: 8,
            offset: 20
          }}>
            <Button type="primary" style={{ backgroundColor: 'green' }} onClick={handleUpdateBudget}>
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
